import { Assets, type Texture } from 'pixi.js';
import chestUrl from '../art/chest.png';
import strongboxUrl from '../art/strongbox.png';
import boneKeyUrl from '../art/boneKey.png';
import shrineUrl from '../art/shrine.png';
import merchantUrl from '../art/merchant.png';
import altarUrl from '../art/altar.png';
import brazierUnlitUrl from '../art/brazierUnlit.png';
import brazierLitUrl from '../art/brazierLit.png';
import springUrl from '../art/spring.png';
import geodeUrl from '../art/geode.png';
import ventUrl from '../art/vent.png';
import debrisUrl from '../art/debris.png';

/**
 * Generated prop textures (ME5) — the first asset pipeline. PNGs live in
 * src/art/ (committed; `npm run gen:art` regenerates) and are pulled in via
 * `import` URLs so vite fingerprints them into dist/assets with RELATIVE
 * paths — required for the Deck/Electron file:// build (`base: './'`).
 * Never move these to public/ + absolute URLs: that 404s under file://.
 * Loaded once at boot (main.ts, beside TextureFactory) and exposed on ctx.
 */
export interface PropTextures {
  chest: Texture;
  strongbox: Texture;
  boneKey: Texture;
  shrine: Texture;
  merchant: Texture;
  altar: Texture;
  brazierUnlit: Texture;
  brazierLit: Texture;
  spring: Texture;
  geode: Texture;
  vent: Texture;
  debris: Texture;
}

const URLS: Record<keyof PropTextures, string> = {
  chest: chestUrl,
  strongbox: strongboxUrl,
  boneKey: boneKeyUrl,
  shrine: shrineUrl,
  merchant: merchantUrl,
  altar: altarUrl,
  brazierUnlit: brazierUnlitUrl,
  brazierLit: brazierLitUrl,
  spring: springUrl,
  geode: geodeUrl,
  vent: ventUrl,
  debris: debrisUrl,
};

export async function loadPropTextures(): Promise<PropTextures> {
  const out: Partial<Record<keyof PropTextures, Texture>> = {};
  await Promise.all(
    (Object.keys(URLS) as (keyof PropTextures)[]).map(async (key) => {
      const tex = await Assets.load<Texture>(URLS[key]);
      tex.source.scaleMode = 'nearest'; // crisp pixels at every zoom
      out[key] = tex;
    }),
  );
  return out as PropTextures;
}
